
















































































import A from '@/utilities/alpha'
import AudiencePrequalPicker from './AudiencePrequalPicker.vue'
import AudiencePrequalList from './AudiencePrequalList.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import preQualificationTypes from '@/utilities/pq-types'
import SplitView from '@/components/SplitView.vue'
import { difference } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Notifications } from './AudienceBuilder.vue'
import * as db from '@shared/types/database'

(preQualificationTypes as any)['Additional Criteria'] = {
  type: 'no type'
}

@Component({
  components: {
    AudiencePrequalList,
    AudiencePrequalPicker,
    AjaxButton,
    SplitView
  }
})
export default class AudienceCreation extends Vue {
  @Prop({ required: true }) readonly savingStatus!: boolean
  @Prop({ default: 'Save & Use' }) readonly saveText!: string
  @Prop({ default: 'Cancel' }) readonly cancelText!: string
  @Prop({ default: () => ({}) }) readonly notifications!: Notifications

  criteria: db.Criteria = {}
  audienceName: string = ''
  selectedCriteria: string[] = []
  preQualificationTypes = preQualificationTypes
  preQualErrors: {[key:string]: string} = {}
  hasAudienceNameMissingError: boolean = false
  hasAudienceNameLengthError: boolean = false
  prequalificationGroups = [
    {
      title: 'Standard Demographics',
      criteria: [
        'Age',
        'Education',
        'Gender',
        'Household Income',
        'State',
        'Parental Status',
        'Relationship Status',
        'Household Type'
      ]
    },
    {
      title: 'Professional',
      criteria: [
        'Employment',
        'Industry',
        '# of Employees',
        'Company Dept.',
        'Job Title',
        'B2B Decisions'
      ]
    },
    {
      title: 'Other',
      criteria: [
        'International',
        'Device',
        'Big Purchases'
      ]
    }
  ]

  get criteriaOrder () {
    return this.prequalificationGroups.reduce((acc, category) => acc.concat(category.criteria), ['Additional Criteria'])
  }

  get AudienceNameCharLimit () {
    return 60
  }

  @Watch('selectedCriteria')
  selectedCriteriaUpdated (newCriterias: string[]) {
    var existingCriteria = Object.keys(this.criteria)
    // Criteria was removed
    if (existingCriteria.length > newCriterias.length) {
      var criteriaToRemove = difference(existingCriteria, newCriterias)[0]
      this.$delete(this.criteria, criteriaToRemove)
    // Criteria was added
    } else if (existingCriteria.length < newCriterias.length) {
      var criteriaToAdd = difference(newCriterias, existingCriteria)[0]
      if (criteriaToAdd === 'Additional Criteria') {
        this.$set(this.criteria, criteriaToAdd, '')
      } else if (['Age', 'Household Income'].includes(criteriaToAdd)) {
        const typedCriteriaToAdd = criteriaToAdd as 'Age' | 'Household Income'
        var min = this.preQualificationTypes[typedCriteriaToAdd].init.min
        var max = this.preQualificationTypes[typedCriteriaToAdd].init.max
        this.$set(this.criteria, typedCriteriaToAdd, [min, max])
      } else {
        this.$set(this.criteria, criteriaToAdd, [])
      }
    }
  }

  mounted () {
    // sets order of prequal list if audience is initially supplied
    if (Object.keys(this.criteria).length) {
      this.selectedCriteria = this.criteriaOrder.filter(value => Object.keys(this.criteria).includes(value))
    }
  }

  cancel () {
    this.$emit('cancel')
  }

  /**
   * Checks for audiencname and if audience demo graphic is sets
   * Creates object errors with Demographics as keys
   * @return false or string of error
   */
  getErrors (payload: { audienceName: string; criteria: db.Criteria }) {
    const { audienceName, criteria } = payload
    var customCriteria = A.clone(criteria)

    this.hasAudienceNameMissingError = audienceName.trim().length === 0
    this.hasAudienceNameLengthError = audienceName.length > this.AudienceNameCharLimit

    this.preQualErrors = Object.keys(customCriteria)
      .filter(criteria => customCriteria[criteria].length === 0)
      .reduce((errObj, criteria) => {
        errObj[criteria] = 'This field is required'
        return errObj
      }, {} as Record<string, string>)

    // Prevent audiences with no qualifications, unfilled qualifications, and no title from being submitted
    if (Object.keys(customCriteria).length === 0) {
      return 'Please select qualification criteria to define custom audience'
    } else if (Object.keys(this.preQualErrors).length > 0 || this.hasAudienceNameMissingError) {
      return 'Please enter the required fields'
    } else if (this.hasAudienceNameLengthError) {
      return 'Please make the audience name less than 60 characters'
    }
  }

  saveCustomPrequal (reciever: AjaxButton) {
    const payload = { reciever, audienceName: this.audienceName, criteria: this.criteria }
    const errors = this.getErrors(payload)
    this.$emit('getCustomPrequal', Object.assign(payload, { errors }))
  }

  updateSelectedCriteria ({ criteria }: { criteria: string }) {
    // remove criteria from the list
    if (this.selectedCriteria.includes(criteria)) {
      const i = this.selectedCriteria.indexOf(criteria)
      this.selectedCriteria.splice(i, 1)
    } else {
      // add criteria to the list
      var selectedCriteriaIdx = 0
      this.criteriaOrder.forEach((c, i) => {
        if (this.selectedCriteria.includes(c)) {
          selectedCriteriaIdx++
        } else if (c === criteria) {
          this.selectedCriteria.splice(selectedCriteriaIdx, 0, criteria)
        }
      })
    }
  }

  updatePrequal ({ prequal, values }: { prequal: string; values: any }) {
    this.$set(this.criteria, prequal, values)
  }
}
